<template>
    <v-dialog v-model="dialog" max-width="600px" persistent>
        <v-card>
            <v-card-title>
                <span class="text-h6">Penilaian Jaminan Mutu Kepatuhan APD</span>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="editedItem.tanggal" type="date" outlined dense hide-details
                            label="Tanggal Penilaian:"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="editedItem.jenis_tindakan" outlined dense hide-details
                            label="Jenis Tindakan :"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field v-model="editedItem.jenis_apd" outlined dense hide-details
                            label="Jenis APD :"></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <label for="">Kepatuhan peserta didik:</label>
                        <v-radio-group v-model="editedItem.kepatuhan" row>
                            <v-radio label="Ya" value="Ya"></v-radio>
                            <v-radio label="Tidak" value="Tidak"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-btn color="primary" @click="saveApd()" v-if="item.verified_at == null">
                    Simpan
                </v-btn>
                <v-btn color="warning" @click="cancelDialog()">
                    Batal
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { axiosPostAuth, axiosGetAuth } from '@/utils/axios'
export default {
    props: {
        dialog: { type: Boolean, default: () => (false) },
        item: { type: Object, default: () => ({}) }
    },
    computed: {
        user() {
            return this.$store.getters.user
        },
    },
    watch: {
        dialog(newValue, oldValue) {
            if (newValue === true) {
                this.getApd(this.item.evaluasi_nmutu_apd_id);
            }
        }
    },
    data() {
        return {
            editedItem: {
                id: '',
                praktik_id: '',
                user_id: '',
                tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                jenis_tindakan: '',
                jenis_apd: '',
                kepatuhan: '',
            },
            defaultItem: {
                id: '',
                praktik_id: '',
                user_id: '',
                tanggal: new Date().toJSON().slice(0, 10).replace(/-/g, '-'),
                jenis_tindakan: '',
                jenis_apd: '',
                kepatuhan: '',
            },
        }
    },
    methods: {
        cancelDialog() {
            this.$emit('handleCancelDialog', false)
        },
        getApd(id) {
            const fmData = new FormData()
            fmData.append('id', id)
            axiosPostAuth('api/Penilaian/getMutuApd', fmData)
                .then(response => {
                    if (response.code === 200) {
                        this.editedItem = Object.assign({}, response.data)
                        // this.dialogApd = true
                    }
                    else {
                        // alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
        saveApd() {
            const fmData = new FormData()
            fmData.append('praktik_id', this.item.praktik_id)
            fmData.append('user_id', this.item.user_id)
            fmData.append('tanggal', this.editedItem.tanggal)
            fmData.append('jenis_tindakan', this.editedItem.jenis_tindakan)
            fmData.append('jenis_apd', this.editedItem.jenis_apd)
            fmData.append('kepatuhan', this.editedItem.kepatuhan)
            axiosPostAuth('api/Penilaian/saveMutuApd', fmData)
                .then(response => {
                    if (response.code === 200) {
                        // this.getDataFromApi()
                        this.$emit('handleSave', false)
                        // this.dialogApd = false
                        this.$emit('handleCancelDialog', false)
                    }
                    else {
                        alert(response.message)
                    }
                })
                .catch(error => {
                    alert(error)
                })
        },
    }
}
</script>